var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 31.418 c 1.209 -0.622 2.591 -0.371 3.889 -0.395 c 2.973 0.078 5.953 -0.072 8.926 0.06 c 1.34 -0.006 2.489 1.107 2.674 2.405 c 0.933 4.523 1.789 9.064 2.704 13.599 c -1.514 -5.313 -5.51 -9.65 -10.207 -12.408 C 5.504 33.189 2.734 32.322 0 31.418 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(244,169,41)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.87 31.035 c 2.579 0.03 5.151 0.018 7.724 0 c -3.913 9.351 -7.562 18.81 -11.559 28.125 c -2.513 -0.078 -5.026 -0.042 -7.538 -0.042 c -2.226 -8.131 -4.302 -16.303 -6.509 -24.44 c 4.697 2.758 8.693 7.096 10.207 12.408 c 0.227 1.029 0.389 2.082 0.586 3.123 C 21.125 43.815 23.501 37.425 25.87 31.035 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,77,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.483 31.023 c 2.423 0.018 4.846 0.018 7.269 0 c -1.49 9.369 -3.057 18.726 -4.511 28.101 c -2.411 0.006 -4.822 0.006 -7.239 0 C 33.39 49.744 35.024 40.399 36.483 31.023 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,77,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.645 32.788 c 4.344 -2.854 10.021 -2.77 14.826 -1.191 c -0.221 2.076 -0.568 4.134 -0.927 6.186 c -2.555 -1.226 -5.534 -1.771 -8.31 -1.059 c -1.31 0.311 -2.603 1.938 -1.514 3.159 c 2.238 2.291 5.761 2.812 7.867 5.307 c 2.441 2.387 2.351 6.408 0.688 9.202 c -1.759 2.95 -5.145 4.493 -8.442 4.936 c -3.727 0.389 -7.61 0.156 -11.104 -1.286 c 0.371 -2.094 0.682 -4.2 1.059 -6.294 c 3.021 1.562 6.527 2.345 9.896 1.597 c 1.143 -0.383 2.321 -1.322 2.22 -2.662 c -0.377 -1.597 -2.046 -2.279 -3.344 -3.003 c -2.519 -1.238 -5.229 -2.758 -6.36 -5.48 C 45.793 38.759 47.653 34.733 50.645 32.788 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,77,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.119 31.059 c -2.226 0.042 -4.463 -0.09 -6.689 0.066 c -1.514 0.078 -2.471 1.484 -2.956 2.776 c -3.5 8.424 -7.042 16.83 -10.548 25.248 c 2.537 -0.006 5.073 -0.006 7.61 -0.006 c 0.532 -1.406 1.047 -2.824 1.544 -4.242 c 3.099 0.018 6.198 0.012 9.303 0.012 c 0.287 1.418 0.586 2.83 0.903 4.236 c 2.238 -0.006 4.475 -0.006 6.713 -0.012 C 88.038 49.78 86.111 40.416 84.119 31.059 z M 75.192 49.121 c 1.352 -3.476 2.459 -7.054 3.973 -10.464 c 0.449 3.53 1.328 6.988 2.052 10.47 C 79.207 49.127 77.203 49.127 75.192 49.121 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,77,162)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaBlueLogo);
export default __webpack_public_path__ + "static/media/visa-blue-logo.dc9da430a0bb591c3021f764b0d94616.svg";
export { ForwardRef as ReactComponent };